'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextPrimaryStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var font = function font(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.menu.item,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight;


  return (0, _styledComponents.css)(['font-size:', ';line-height:', ';'], (0, _reactackleCore.getValueString)(fontSize), lineHeight);
};

var TextPrimaryStyled = exports.TextPrimaryStyled = _styledComponents2.default.div.withConfig({
  displayName: 'TextPrimaryStyled'
})(['color:currentColor;', ' ', ''], font, (0, _reactackleCore.transition)('color'));

TextPrimaryStyled.displayName = 'TextPrimaryStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-menu/dist/MenuItem/styles/TextPrimaryStyled.js
// module id = 747
// module chunks = 0